import { Icon } from 'anf-core-react';
import PropTypes from 'prop-types';
import React from 'react';
import style from './AppliedFacetButton.module.scss';

function AppliedFacetButton({
  name, onClick = () => {}, labelText, hasIcon = false,
}) {
  return (
    <button
      className={style.appliedFacetButton}
      onClick={onClick}
      type="button"
    >
      <span>{name}</span>
      {hasIcon ? <Icon icon="close" labelText={labelText} size="xs" /> : null}
    </button>
  );
}

export default AppliedFacetButton;

AppliedFacetButton.propTypes = {
  name: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  hasIcon: PropTypes.bool,
};
